import '../../css/base.css';

const Shopping = () => {

  return (
    <div>
      <h2 className="your-stay-section-heading">Shopping</h2>
      <p className="your-stay-text">Glenelg (9 miles).  Small shop and post office.
      </p>                                            
      <p className="your-stay-text">Inverinate Garage (22 miles).  Small shop and petrol.
      </p>
      <p className="your-stay-text">Kyle (34 miles).  Large Co-op.
      </p>
      <p className="your-stay-text">Broadford (on Skye)  Large Co-op.
      </p>
      <h2 className="your-stay-section-heading">Stocking Up</h2>
      <p className="your-stay-text">Fort William (route through Glen Coe).  Large Morrisons, Marks and Spencers and Lidl.
      </p>                                            
      <p className="your-stay-text">Pitlochry (route up A9).  Co-op behind the high street on the right.
      </p>
      <h2 className="your-stay-section-heading">Deliveries</h2>
      <p className="your-stay-text">Fresh fish and seafood from the Skye Bridge Seafoods van on Wednesdays.  Tel: 01599 530260 and 07766529907.
      </p>                                           
      <p className="your-stay-text">Morrisons.  Deliveries to Arnisdale have just started but slots seem to be hard to come by.  Will update 
                                    this information when we know more about when slots are released.
      </p>

    </div>
  );
}

export default Shopping;